import { render, staticRenderFns } from "./title-rounded.vue?vue&type=template&id=f1debb9a&scoped=true&"
import script from "./title-rounded.vue?vue&type=script&lang=js&"
export * from "./title-rounded.vue?vue&type=script&lang=js&"
import style0 from "./title-rounded.vue?vue&type=style&index=0&id=f1debb9a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1debb9a",
  null
  
)

export default component.exports